<template>
    <div class="container vh-100 d-flex justify-content-sm-center align-items-sm-center">
        <div class="row bg-dark bg-gradient p-sm-5">
            <div class="col-12 col-sm-7 order-1 order-sm-2 login-image">
                <img :src="G.projectLogo" alt="...">
                <div class="my-sm-4 fw-normal small text-center text-white d-none1 d-sm-block">{{G.footerDescription}}</div>
            </div>
            <div class="col-12 col-sm-4 offset-sm-1 order-2 order-sm-1 text-light p-4 d-flex justify-content-center align-items-center">
                <main class="form-signin">
                    <form class="text-center">
                        <!-- <h1 class="h3 mb-4 fw-normal">{{G.projectName}}</h1> -->
                        <h1 class="h3 mb-2 mb-sm-5 fw-normal w-100">{{TR.login_title}}</h1>
                        <!-- <h1 class="h6 mb-5 fw-normal text-info">{{G.projectName}}</h1> -->
                        <div class="mb-2">
                            <div
                                :class="loginError ? 'd-block' : 'd-none' "
                                class="login-error-msg-div text-warning fs-7 text-wrap my-3"
                                v-html="TR.msg_login_failed"
                            ></div>
                                <!-- v-html="TR.msg_login_failed" -->
                            <div :class="loginError ? 'd-none' : 'd-block' ">&nbsp;&nbsp;&nbsp;</div>
                        </div>

                        <div class="form-floating">
                            <input
                                type="email"
                                class="form-control border-0 border-bottom border-secondary bg-transparent text-light mb-21"
                                id="floatingInput"
                                autofocus="true"
                                autocomplete="off"
                                placeholder=""
                                v-model="email"
                                @input="changeInput"
                                @keyup.enter="auth"
                            />
                            <label for="floatingInput">{{TR.email}}</label>
                        </div>
                        <div class="form-floating">
                            <input
                                type="password"
                                class="form-control border-0 border-bottom border-secondary bg-transparent text-light"
                                id="floatingPassword"
                                placeholder=""
                                autocomplete="off"
                                v-model="password"
                                @input="changeInput"
                                @keyup.enter="auth"
                            />
                            <label for="floatingPassword">{{TR.password}}</label>
                        </div>

                        <!-- <div class="checkbox mt-4">
                            <label class="cursor-pointer">
                                <input type="checkbox" value="remember-me" class="me-1" />
                                {{TR.profile_remember}}
                            </label>
                        </div> -->
                        <button
                            class="w-100 btn btn-lg btn-dark mt-5"
                            type="button"
                            @click="auth"
                        >{{TR.signin}}</button>
                        <p class="mt-sm-5 mt-5 text-muted" v-html="footerInfo"></p>
                    </form>
                </main>
            </div>
        </div>
    </div>
</template>


<script scoped>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from "@/store";

    import { useRouter, useRoute } from "vue-router";
    import { G, ajax } from "@/_common";

    export default {
        name: "LoginBlackImageP",
        setup() {
            const store = useStore();
            const router = useRouter();
            const route = useRoute();

            const TR = ref({});

            watchEffect(() => {
                TR.value = store.getTranslation();
            });

            const email = ref("");
            const password = ref("");
            const loginError = ref(false);
            const footerInfo = G.footerPowered;


            onMounted(() => {
                G.removeClientData("AUTH_TOKEN");
            });

            const changeInput = () => {
                loginError.value = false;
            };

            const auth = async (e) => {
                e.preventDefault();
                loginError.value = false;

                let loginData = new FormData();
                loginData.append("email", email.value);
                loginData.append("password", password.value);

                await ajax({
                    method: 'post',
                    url: store.getLogin(),
                    data: loginData,
                    success: async (e) => {
                        let res = e.data || null;
                        if (res && res.token && res.token.length > 0) {
                            G.token = res.token;
                            G.setClientData("AUTH_TOKEN", res.token);

                            if( route.query && route.query.redirect && route.query.redirect != '' )
                                router.push(route.query.redirect);
                            else{
                                // router.push({name: 'agenda'});
                                router.push({path: '/'});
                                // router.push('/');
                            }
                        }
                        // else {
                        //     G.removeClientData("AUTH_TOKEN");
                        // }
                    },
                    error: (error) => {
                        var res = error.response || {};
                        if (res.status == 422 && document.getElementsByClassName('login-error-msg-div').length){
                            document.getElementsByClassName('login-error-msg-div')[0].innerHTML = res.data.detail;
                        }
                        loginError.value = true;

                        // G.removeClientData("AUTH_TOKEN");
                    }
                });
            };

            return { G, email, password, loginError, auth, footerInfo, TR, changeInput };
        },
    };
</script>

<style lang="scss">
.login-image{
    text-align: center;
}
.login-image img{
    object-fit: contain;
    height: 100%;
}
.form-signin {
    width: 100%;
}
.form-signin input {
    background: transparent;
    border-radius: 0;
}
@media(max-width: 576px){
    .login-image img{
        width: 50%;
        text-align: center;
        justify-content: center;
        align-self: center;
    }
}
// .loginLogo{
//     background: linear-gradient(70deg, rgb(172, 172, 172) , rgb(18, 71, 92));
//     // background: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
// }
</style>

